export default function UtilitySevice() {
	this.isValidDate = function(dateStr) {
		if (dateStr === undefined) return false;
		var dateTime = Date.parse(dateStr);

		if (isNaN(dateTime)) {
			return false;
		}
		return true;
	};

	this.getDateDifference = function(fromDate, toDate) {
		return Date.parse(toDate) - Date.parse(fromDate);
	};

	this.isValidDateRange = function(fromDate, toDate) {
		if (fromDate === '' || toDate === '') return true;
		if (this.isValidDate(fromDate) === false) {
			return false;
		}
		if (this.isValidDate(toDate) === true) {
			var days = this.getDateDifference(fromDate, toDate);
			if (days < 0) {
				return false;
			}
		}
		return true;
	};

	this.isValidMinDateRange = function(fromDate, toDate) {
		var from = new Date(fromDate);
		var to = new Date(toDate);
		from.setHours(0);
		from.setMinutes(0);
		to.setHours(0);
		to.setMinutes(0);
		var timeDiff = Math.abs(from.getTime() - to.getTime());
		var dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
		if (dayDiff >= 32) return false;
		return true;
	};
}
